/**
 * Generated runtime TestId mirror for frontend/src/pages/RoleDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const RoleDetailTestIds = {
  btnCancelEditPermissions: "btn-cancel-edit-permissions",
  btnDeleteRole: "btn-delete-role",
  btnEditPermissions: "btn-edit-permissions",
  btnEditRole: "btn-edit-role",
  btnSavePermissions: "btn-save-permissions",
  cardTitlePermissions: "card-title-permissions",
  colResource: "col-resource",
  inputFilterPermissions: "input-filter-permissions",
  roleDescriptionValue: "role-description-value",
  roleDetailPage: "role-detail-page",
  roleKeyValue: "role-key-value",
  roleMetaCard: "role-meta-card",
  colAction: (action: string) => `col-action-${action}`,
  colActionPrefix: () => "col-action-" as TestIdPrefix
} as const;
